import React from 'react';

const SvgIq = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="IQ_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="IQ_svg__b" fill="#fff">
        <use xlinkHref="#IQ_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path fill="#DF1E35" mask="url(#IQ_svg__b)" d="M0 0h28v6.667H0z" />
      <path fill="#262626" mask="url(#IQ_svg__b)" d="M0 13.333h28V20H0z" />
      <path
        d="M18.667 8.341c0-.188.132-.275.296-.193l.741.37a.58.58 0 0 1 .296.48v2.67a.33.33 0 0 1-.336.332h-.66a.338.338 0 0 1-.337-.341V8.341zM10.667 8.341c0-.188.132-.275.296-.193l.741.37a.58.58 0 0 1 .296.48v2.67a.33.33 0 0 1-.336.332h-.66a.338.338 0 0 1-.337-.341V8.341zM16 8.998c0-.183.133-.398.296-.48l.741-.37c.164-.082.296.004.296.193v3.318a.334.334 0 0 1-.336.341h-.66a.33.33 0 0 1-.337-.332v-2.67z"
        fill="#0F7A40"
        mask="url(#IQ_svg__b)"
      />
      <path
        d="M13.333 10.33c0-.182.133-.396.296-.478l.742-.37c.163-.082.296 0 .296.189v1.055h2V12H13.67a.34.34 0 0 1-.337-.33v-1.34zM8 10.33c0-.182.133-.396.296-.478l.741-.37c.164-.082.296 0 .296.189v1.055h2V12H8.337A.34.34 0 0 1 8 11.67v-1.34z"
        fill="#0F7A40"
        mask="url(#IQ_svg__b)"
      />
    </g>
  </svg>
);

export default SvgIq;
